import { getCategoryHierarchy } from '../../../actions/management/methods/get-category-hierarchy'
import { responseHandlerService } from '@/plugins/responseHandlerService'
import { buildSubCategoriesMap } from './build-sub-categories-map'

/**
 * Fetches categories and processes them for display
 * @param {string|number} assetId - The asset ID
 * @param {Object} options - Fetch options
 * @param {Function} i18n - Translation function
 * @returns {Object} - Categories data and error status
 */
export const fetchCategories = async (assetId, options = {}, i18n) => {
  try {
    const result = await getCategoryHierarchy(assetId, options)
    
    // Filter custom categories if needed
    const filteredCategories = options.isCustom 
      ? result.data.filter(category => category.is_custom === 1 || category.is_custom === true)
      : result.data
    
    // Process and cache subcategories
    const subCategoriesMap = buildSubCategoriesMap(result.data)
    
    return {
      categories: filteredCategories,
      subCategories: subCategoriesMap,
      error: null
    }
  } catch (error) {
    const errorMessage = i18n ? i18n('settings.components.configuration.components.categoryModal.common.error.fetchCategories') : 'Error fetching categories'
    responseHandlerService.handleError(errorMessage)
    
    return {
      categories: [],
      subCategories: {},
      error
    }
  }
}
